import { Injectable } from '@angular/core';
import { CustomersVoiceTaxonomyModel } from '@big-direkt/utils/shared';
import { ResourceTypes } from '../../models/resource.types';
import { TaxonomyTermCustomersVoiceResource } from '../../models/resources/taxonomy-customers-voice.resource';
import { JsonApiResourceMapper } from '../json-api-resource-mapper.decorator';
import { ResourceMapper } from './resource.mapper';

@Injectable({
    providedIn: 'root',
})
@JsonApiResourceMapper
export class TaxonomyTermCustomersVoiceMapper extends ResourceMapper<CustomersVoiceTaxonomyModel> {
    public static override readonly type: ResourceTypes = ResourceTypes.TaxonomyTermCustomersVoice;

    public map(resource: TaxonomyTermCustomersVoiceResource): CustomersVoiceTaxonomyModel {
        return {
            date: resource.attributes.date ? new Date(resource.attributes.date) : new Date(),
            starRating: Number(resource.attributes.star_rating ?? ''),
            title: resource.attributes.title ?? '',
            description: resource.attributes.description?.processed,
            name: resource.attributes.name ?? '',
            subTitle: resource.attributes.subtitle ?? undefined,
        };
    }
}
